import React, { useState, useEffect, useRef } from "react"
import { Link } from "gatsby"
import Layout from "@components/layout"
import SEO from "@components/seo"
import WebriqForm from "@webriq/gatsby-webriq-form"
import { LazyLoadComponent } from "react-lazy-load-image-component"
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap"
import { StaticImage } from "gatsby-plugin-image"
import video from "../images/help-center/help-center-video.mp4"
import Helmet from "react-helmet"

import Script from "react-inline-script"

const HelpCenter = () => {
  const [activeTab, setActiveTab] = useState("1")
  const [activeTab2, setActiveTab2] = useState("9")

  // Comment this out while doing updates on site
  // Uncomment this block when pushing changes
  useEffect(() => {
    GiftcardWidget.init({
      container: "#giftcard-container",
      client_id: "key_live_rMAR_qiCEFETLIIROp0XqHyEz86mh0JzkAo69lJJLyI",
      platform: "BIGCOMMERCE",
    })
  }, [])

  return (
    <Layout>
      <SEO title="Support Center" />
      <div className="help-center">
        {" "}
        <section className="heading d-flex align-items-center">
          <div className="container">
            <h2 className="section-title text-uppercase  text-white text-center">
              Support Center
            </h2>
          </div>
        </section>
        <div className="page-body">
          <div className="container">
            <p className="note text-center">
              For the fastest resolution, please call our customer service
              during business hours. It often takes us 48 hours to respond to
              email submissions.
            </p>
            <div className="row">
              <div className="my-2 col-lg-4">
                <Link to="/app/login" className="nav-buttons h-100">
                  <h3>ORDERS</h3>
                </Link>
              </div>
              <div className="my-2 col-lg-4">
                {" "}
                <div
                  className={`nav-buttons h-100 ${
                    activeTab == "9" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("9")}
                >
                  <h3>GIFT CARDS</h3>
                </div>
              </div>{" "}
              <div className="my-2 col-lg-4">
                <div
                  className={`nav-buttons h-100 ${
                    activeTab == "8" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("8")}
                >
                  <h3>RETURNS & EXCHANGES</h3>
                </div>
              </div>
              <div id="support-navs" />
              <div className="col-lg-12 mt-5">
                <Nav className="row main-tab-nav">
                  <NavItem className="col-sm">
                    {" "}
                    <NavLink
                      className={`text-center tab-navbox ${
                        activeTab == "1" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("1")}
                    >
                      <div className="tab-icon">
                        <StaticImage
                          width={70}
                          src="../images/help-center/hc-icon.png"
                        />
                      </div>
                      <p>
                        Policies & <br />
                        Terms of Use
                      </p>
                    </NavLink>
                  </NavItem>

                  <NavItem className="col-sm">
                    {" "}
                    <NavLink
                      className={`text-center tab-navbox ${
                        activeTab == "2" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("2")}
                    >
                      <div className="tab-icon">
                        <StaticImage
                          width={63}
                          src="../images/help-center/si.png"
                        />
                      </div>
                      <p>
                        Shipping & <br />
                        Information
                      </p>
                    </NavLink>
                  </NavItem>
                  {/* <NavItem className="col-sm">
                    {" "}
                    <NavLink
                      className={`text-center tab-navbox ${
                        activeTab == "3" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("3")}
                    >
                      <div className="tab-icon">
                        <StaticImage
                          width={70}
                          src="../images/help-center/hc-icon3.png"
                        />
                      </div>
                      <p>FAQ</p>
                    </NavLink>
                  </NavItem> */}
                  <NavItem className="col-sm">
                    {" "}
                    <NavLink
                      className={`text-center tab-navbox ${
                        activeTab == "4" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("4")}
                    >
                      <div className="tab-icon">
                        <StaticImage
                          width={70}
                          src="../images/help-center/hc-icon4.png"
                        />
                      </div>
                      <p>Call Us</p>
                    </NavLink>
                  </NavItem>
                  <NavItem className="col-sm">
                    {" "}
                    <NavLink
                      className={`text-center tab-navbox ${
                        activeTab == "5" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("5")}
                    >
                      <div className="tab-icon">
                        <StaticImage
                          width={70}
                          src="../images/help-center/hc-icon5.png"
                        />
                      </div>
                      <p>Email Us</p>
                    </NavLink>
                  </NavItem>
                  <NavItem className="col-sm">
                    {" "}
                    <NavLink
                      className={`text-center tab-navbox ${
                        activeTab == "6" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("6")}
                    >
                      <div className="tab-icon">
                        <StaticImage
                          width={70}
                          src="../images/help-center/hc-icon2.png"
                        />
                      </div>
                      <p>Write Us</p>
                    </NavLink>
                  </NavItem>
                  <NavItem className="col-sm">
                    {" "}
                    <NavLink
                      className={`text-center tab-navbox ${
                        activeTab == "7" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("7")}
                    >
                      <div className="tab-icon">
                        <StaticImage
                          width={70}
                          src="../images/help-center/hc-icon6.png"
                        />
                      </div>
                      <p>Engage</p>
                    </NavLink>
                  </NavItem>
                </Nav>
              </div>
            </div>
          </div>
          <div className="tab-content">
            <video
              className="video-bg"
              playsinline="playsinline"
              autoplay="autoplay"
              loop
              muted
            >
              <source src={video} type="video/mp4" />
            </video>
            <div className="container">
              {" "}
              <div className="row">
                <div className="col-lg-9 mx-auto">
                  {" "}
                  <TabContent activeTab={activeTab}>
                    <TabPane tabId="1">
                      <div className="tab-content-box">
                        <div className="tab-content-inner">
                          {" "}
                          <p className="font-weight-bold">Privacy Policy</p>
                          <p className="text-block">
                            This policy describes how FLUO LLC. and its parent,
                            subsidiary, and affiliate companies (collectively,
                            “FLUO,” “we,” or “us”) collect, use and share
                            information collected through the mail,
                            FLUOFeelAlive.com, other websites that link to this
                            privacy policy, and FLUO mobile services including
                            our mobile application (the “FLUO App”, or "App"),
                            collectively, "FLUO Services".
                          </p>
                          <p className="font-weight-bold">
                            HOW WE COLLECT AND USE INFORMATION
                          </p>
                          <p className="font-weight-bold">
                            Data and Personal Information (“PI”)
                          </p>
                          <p className="text-block">
                            We or our vendors may collect data and/or personal
                            information (“PI”) such as your name, your contact
                            information, your shipping information, and your
                            billing information (such as credit card account
                            data). We collect PI when you provide it to us
                            through your use of the FLUO Services, for example
                            when you interact with our websites, place an order,
                            or sign up for our mailing list. We also receive
                            limited PI when you choose to download or request
                            the App. We may combine the PI we collect with
                            additional information from other third-party
                            sources.
                          </p>
                          <p className="font-weight-bold">
                            Geographic Location
                          </p>
                          <p className="text-block">
                            Our App uses the GPS feature of your mobile device
                            to determine the location of the device. We and our
                            third-party vendors or partners may collect and use
                            this geographic location data for purposes such as
                            the functioning of the FLUO App, to make our
                            advertising more relevant, and to improve FLUO
                            Services. For example, we use the location
                            information to provide the address and directions
                            for FLUO events (music events, health and wellness
                            events, etc.). We do not store geographic location
                            data in combination with other PI. If you do not
                            want us or third parties to collect and use your
                            device’s geographic location, you can control this
                            function in your application settings (if your
                            device offers this type of control), by disabling
                            location services for your device, or by
                            uninstalling the App, but these choices will affect
                            your ability to use the App.
                          </p>
                          <p className="font-weight-bold">
                            Usage Information and Analytics
                          </p>
                          <p className="text-block">
                            We automatically collect certain usage information
                            when you use FLUO Services. For example, we collect
                            information about the devices you use to connect to
                            our services (such as the IP address of your
                            computer or numeric identifier of your mobile
                            device) and about how you use FLUO Services (such as
                            what time you visit our websites). We, and our
                            advertisers and ad servers, may also collect
                            information outside the Patagonia Services to
                            measure the success of our advertising campaigns. We
                            use the information that we collect for a variety of
                            purposes such as to provide and improve the FLUO
                            Services, and to analyze and offer our advertising.
                            Our website also uses Google Analytics. Please click
                            here for more information about how data is
                            collected and processed in connection with the
                            Google Analytics service. We and our third-party
                            vendors or partners use analytics data for a variety
                            of purposes such as to improve the design and
                            content of our websites, to help us learn things
                            like what pages are most attractive to all of our
                            visitors and what promotions visitors like to see,
                            and to gauge the success of our advertising
                            campaigns.
                          </p>
                          <p className="font-weight-bold">
                            HOW WE SHARE INFORMATION
                          </p>
                          <p className="text-block">
                            We do not disclose your PI to third parties, except
                            as follows:
                          </p>
                          <ul>
                            <li>
                              To companies that provide services to us or
                              perform functions on our behalf (such as
                              processing credit card payments or taking orders)
                              and have agreed to use your information only for
                              the purposes we request;
                            </li>
                            <li>
                              When we believe disclosure is appropriate to
                              comply with applicable law, legal process, and/or
                              governmental authorities;
                            </li>
                            <li>
                              When we believe disclosure is appropriate to
                              enforce our Terms of Use and other agreements, or
                              to protect our rights, our customers, our
                              property, our employees, or others
                            </li>
                          </ul>
                          <p className="font-weight-bold">YOUR CHOICES</p>
                          <p className="text-block">
                            With your PI – like the information you give us to
                            fulfill an order – you have the option to change or
                            correct your information and the choice of not
                            hearing from us again. There are several ways you
                            can control our use of your PII in connection with
                            marketing and promotions.
                          </p>
                          <p className="text-block">
                            To remove your name from our lists. You can choose
                            to decline communications from us at the point that
                            we request your PI. After we have collected your PI,
                            you can choose to stop our communications or our
                            service or stop us from sharing your information
                            with other companies for their marketing purposes.
                            To exercise any of these options, please contact us
                            by mail, email, or telephone using the contact
                            information below.
                          </p>
                          <p className="text-block">
                            To stop email communications. If you receive email
                            communications from us and want to opt out of
                            receiving such communications in the future, you can
                            click the “Unsubscribe” link at the bottom of the
                            promotional email.
                          </p>
                          <p className="text-block">
                            To stop collection of geographic location. If you do
                            not want us to collect your device’s geographic
                            location through our FLUO App, you can disable that
                            function when you first use the App or in your
                            device settings. This will prevent you from using
                            some features of the FLUO App.
                          </p>
                          <p className="text-block">
                            Other choices. Please see below to learn about your
                            choices with regard to our use of cookies and
                            interest-based advertising.
                          </p>
                          <p className="font-weight-bold">
                            CORRECTING OR UPDATING YOUR INFORMATION
                          </p>
                          <p className="text-block">
                            If you would like to request changes to the PI that
                            you have previously provided to us, please contact
                            us by mail, email, or telephone using the contact
                            information below.
                          </p>
                          <p className="font-weight-bold">COOKIES</p>
                          <p className="text-block">
                            We may use “cookies,” “web beacons,” and other
                            similar technologies to collect information in
                            connection with the Patagonia Services and our
                            advertisements. A “cookie” is a computer file that
                            acts as an identification card for your computer to
                            distinguish your browser from others and enable us
                            to serve you better. For example, we use cookies to
                            save products in your shopping cart while you browse
                            our websites and to track the effectiveness of our
                            marketing and advertising campaigns. Similarly, a
                            “web beacon” is a technology that can recognize
                            specific cookies and convey information about that
                            browser. We may also use technologies, such as our
                            own cookies, to provide you with personalized online
                            display advertising tailored to your interests. Most
                            browsers accept cookies automatically. You may be
                            able to set your browser to reject and/or delete
                            cookies. For instructions, check your browser’s
                            technical information.
                          </p>
                          <p className="font-weight-bold">
                            SAFEGUARDING YOUR PI
                          </p>
                          <p className="text-block">
                            We have reasonable and appropriate physical,
                            electronic, and administrative measures in place to
                            safeguard the security of your personal information.
                            However, when you communicate with customer service
                            via email or chat on our websites, these
                            communications may not be encrypted. For that
                            reason, we ask that you do not share sensitive
                            information via these communication channels.
                          </p>
                          <p className="font-weight-bold">
                            YOUR PRIVACY RIGHTS
                          </p>
                          <p className="text-block">
                            The California Consumer Privacy Act (“CCPA”) and,
                            potentially, other applicable state or federal laws
                            provide you with rights regarding how your data or
                            personal information is treated.
                          </p>
                          <p className="text-block">
                            <em>Your Rights Regarding Personal Information.</em>{" "}
                            You have the following rights with respect to the
                            personal information we collect, subject to certain
                            exceptions and limitations:
                          </p>
                          <ul>
                            <li>
                              For certain categories of personal information,
                              the right to request a list of what personal
                              information (if any) we disclosed to third parties
                              for their own direct marketing purposes in the
                              preceding calendar year and the names and
                              addresses of those third parties;
                            </li>
                            <li>
                              The right to know the categories and/or specific
                              pieces of personal information we collect, use,
                              disclose, and sell about you, the categories of
                              sources from which we collected your personal
                              information, our purposes for collecting or
                              selling your personal information, the categories
                              of your personal information that we have either
                              sold or disclosed for a business purpose, and the
                              categories of third parties with which we have
                              shared personal information;
                            </li>
                            <li>
                              The right to request that we delete the personal
                              information we have collected from you or maintain
                              about you.
                            </li>
                            <li>
                              The right to opt out of our sale of your personal
                              information.
                            </li>
                            <li>
                              The right not to receive discriminatory treatment
                              for the exercise of your privacy rights under the
                              CCPA.
                            </li>
                          </ul>
                          <p className="text-block">
                            To exercise any of the above rights, please contact
                            us using the following information and submit the
                            required verifying information, as further described
                            below:
                          </p>
                          <p className="text-block">
                            By phone at{" "}
                            <a href="tel:1-303-835-3535" className="text-body">
                              <u>1-303-835-3535</u>
                            </a>
                            <br />
                            <a
                              href="mailto:privacyandterms@FLUOFeelAlive.com"
                              className="text-body"
                            >
                              <u>privacyandterms@FLUOFeelAlive.com</u>
                            </a>
                          </p>
                          <p className="font-weight-bold">
                            UPDATES TO THE PRIVACY POLICY
                          </p>
                          <p className="text-block">
                            If we modify this Privacy Policy, we will post the
                            revised Privacy Policy online. We will notify you if
                            the policy changes in any material way by sending a
                            notice to the email address you provided us or by
                            placing a prominent notice on our website at
                            FLUOFeelAlive.com. You should check regularly to see
                            if this Privacy Policy has changed.
                          </p>
                          <p className="font-weight-bold">CONTACT US</p>
                          <p className="text-block">
                            If you have any questions about this Privacy Policy,
                            you can email, write, or call us:
                          </p>
                          <ul>
                            <li>
                              <a
                                href="mailto:privacyandterms@FLUOFeelAlive.com"
                                className="text-body"
                              >
                                <u>privacyandterms@FLUOFeelAlive.com</u>
                              </a>
                            </li>
                            <li>
                              FLUO Customer Services
                              <br />
                              1905 15th Street
                              <br />
                              UNIT 4315
                              <br />
                              Boulder, CO 80306
                            </li>
                            <li>
                              <a
                                href="tel:1-303-835-3535"
                                className="text-body"
                              >
                                <u>1-303-835-3535</u>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </TabPane>
                    <TabPane tabId="2">
                      {" "}
                      <div className="tab-content-box">
                        <h2 className="font-weight-bold">SHIPPING POLICY</h2>

                        <h5 className="font-weight-bold mt-4">
                          SHIPPING IS ON US!
                        </h5>
                        <p>
                          FREE standard domestic shipping on orders of $150 or
                          more*
                        </p>

                        <h5 className="font-weight-bold mt-4">
                          SHIPPING TIMES/DETAILS:
                        </h5>
                        <p>
                          Please allow 1-2 business days after order is placed
                          for shipment. Contact us directly at{" "}
                          <a
                            className="primary-color"
                            href="mailto:orders@FLUOFeelAlive.com"
                          >
                            orders@FLUOFeelAlive.com
                          </a>{" "}
                          for special orders or if you need something sooner and
                          we will do our best to accommodate your needs.
                          Packages shipped with USPS standard delivery are
                          subject to USPS delivery times, and typically arrive
                          within 3-7 business days.
                        </p>
                        <p>
                          *Free shipping is valid on orders of $150 or more
                          shipped to a single U.S. address, after promotions and
                          discounts are applied. Gift cards and taxes do not
                          qualify toward the minimum purchase requirement. Offer
                          and delivery times are subject to change without
                          notice.
                        </p>
                      </div>
                    </TabPane>
                    <TabPane tabId="3">
                      {" "}
                      <div className="tab-content-box text-center"></div>
                    </TabPane>
                    <TabPane tabId="4">
                      {" "}
                      <div className="tab-content-box text-center">
                        <p>Please call us at</p>
                        <h3>
                          <a className="tab-content-link" href="tel:3038353535">
                            303 835 3535
                          </a>
                        </h3>
                        <p>
                          We're in the office and happy to hear from you:
                          <strong>
                            9am to 5pm, Monday through Friday, Mountain Standard
                            Time.
                          </strong>{" "}
                          We're offline and out exploring on Saturday and
                          Sunday.
                        </p>
                      </div>
                    </TabPane>
                    <TabPane tabId="5">
                      {" "}
                      <div className="tab-content-box">
                        {" "}
                        <h3 className="font-weight-bold">Email Us</h3>
                        <small>
                          Required Fields{" "}
                          <span style={{ color: "red" }}>*</span>
                        </small>
                        <LazyLoadComponent>
                          <WebriqForm
                            webriqform="true"
                            name="Join the Revolution"
                            id="revolution"
                            className="revolution-form"
                            data-form-id="bfdae50f-1e32-424a-ba0c-847b42137b28"
                            data-thankyou-url="/thank-you"
                          >
                            <div className="form-group my-4">
                              <label>
                                Email Address{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="email"
                                className="form-control"
                                name="Email address"
                                required
                              />
                              <label className="mt-4">
                                First Name{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="First Name"
                                required
                              />

                              <label className="mt-4">
                                Last Name{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="Last Name"
                                required
                              />

                              <label className="mt-4">Company</label>
                              <input
                                type="text"
                                className="form-control"
                                name="Company"
                              />

                              <label className="mt-4">
                                Primary #{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="Primary Number"
                                required
                              />
                              <small>
                                <em>Expected Input: ##########</em>
                              </small>
                              <br />
                              <label className="mt-4">
                                Message <span style={{ color: "red" }}>*</span>
                              </label>
                              <textarea
                                type="textarea"
                                className="form-control"
                                name="Message"
                                required
                                rows="6"
                              />
                              {/* <label className="mt-4">
                                Street <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="street"
                                className="form-control"
                                name="Street"
                                required
                              />

                              <label className="mt-4">
                                City <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="city"
                                className="form-control"
                                name="City"
                                required
                              />

                              <label className="mt-4" for="country">
                                Country <span style={{ color: "red" }}>*</span>
                              </label>
                              <select
                                id="country"
                                name="country"
                                className="form-control"
                              >
                                <option value="" disabled selected>
                                  Select your country
                                </option>

                                <option value="Canada">Canada</option>
                                <option value="United States">
                                  United States
                                </option>
                              </select>

                              <label className="mt-4">
                                State or Province{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="state"
                                className="form-control"
                                name="State or Province"
                                required
                              />

                              <label className="mt-4">
                                Zip/Postal Code{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="zipcode"
                                className="form-control"
                                name="Zip/Postal Code"
                                required
                              /> */}
                              <div className="webriq-recaptcha" />
                              <button
                                className="footer-button mt-4"
                                type="submit"
                              >
                                Submit
                              </button>
                            </div>
                          </WebriqForm>
                        </LazyLoadComponent>
                      </div>
                    </TabPane>
                    <TabPane tabId="6">
                      {" "}
                      <div className="tab-content-box text-center">
                        <p>Please call us at</p>
                        <h3>
                          <a
                            className="tab-content-link"
                            href="https://goo.gl/maps/QnVLP7iiU3shWbgV7"
                            target="_blank"
                            rel="noreference noopener"
                          >
                            1905 15th Street #4315 Boulder, CO 80306
                          </a>
                        </h3>
                        <p>
                          We're in the office and happy to hear from you:
                          <strong>
                            <br />
                            9am to 5pm, Monday through Friday, Mountain Standard
                            Time.
                            <br />
                          </strong>{" "}
                          We're offline and out exploring on Saturday and
                          Sunday.
                        </p>
                      </div>
                    </TabPane>
                    <TabPane tabId="7">
                      <div className="tab-content-box text-center">
                        <p>Please visit us on your favorite platforms</p>
                        <div className="socials d-flex justify-content-center mb-3">
                          <a
                            href="https://www.instagram.com/FLUOFeelAlive/"
                            target="_blank"
                            className="m-1"
                          >
                            <StaticImage
                              width={45}
                              height={45}
                              layout="fixed"
                              src="../images/help-center/socials/insta.svg"
                            />
                          </a>
                          <a
                            href="https://www.facebook.com/FLUOFeelAlive/"
                            target="_blank"
                            className="m-1"
                          >
                            <StaticImage
                              width={45}
                              height={45}
                              layout="fixed"
                              src="../images/help-center/socials/fb.svg"
                            />
                          </a>
                          <a
                            href="https://www.youtube.com/channel/UCbXUCc-pw5mIo5dNoTB0qoQ"
                            target="_blank"
                            className="m-1"
                          >
                            <StaticImage
                              width={45}
                              height={45}
                              layout="fixed"
                              src="../images/help-center/socials/yt.svg"
                            />
                          </a>
                          <a
                            href="https://www.linkedin.com/company/fluofeelalive/"
                            target="_blank"
                            className="m-1"
                          >
                            <StaticImage
                              width={45}
                              height={45}
                              layout="fixed"
                              src="../images/help-center/socials/ln.svg"
                            />
                          </a>
                          <a
                            href="https://www.pinterest.com/"
                            target="_blank"
                            className="m-1"
                          >
                            <StaticImage
                              width={45}
                              height={45}
                              layout="fixed"
                              src="../images/help-center/socials/pint.svg"
                            />
                          </a>
                        </div>
                        <p>
                          Our customer service team is always happy to connect
                          on socials.{" "}
                          <strong>
                            9am to 5pm, Monday through Friday, Mountain Standard
                            Time.
                          </strong>{" "}
                          We're offline and out exploring on Saturday and
                          Sunday.
                        </p>
                      </div>
                    </TabPane>
                    <TabPane tabId="8">
                      {" "}
                      <div className="tab-content-box">
                        <p className="font-weight-bold text-center">
                          RETURNS AND EXCHANGES
                        </p>
                        <Nav tabs className="returns-tab">
                          <NavItem>
                            <NavLink
                              className={activeTab2 == "9" ? "active" : ""}
                              onClick={() => setActiveTab2("9")}
                            >
                              U.S. RETURNS
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              className={activeTab2 == "10" ? "active" : ""}
                              onClick={() => setActiveTab2("10")}
                            >
                              Return Form
                            </NavLink>
                          </NavItem>
                        </Nav>
                        <TabContent activeTab={activeTab2}>
                          <TabPane tabId="9">
                            <div>
                              <p className="font-weight-bold text-center">
                                U.S. ONLINE RETURNS
                              </p>
                              <p>
                                TO QUALIFY FOR A RETURN OR EXCHANGE, ITEMS
                                PURCHASED MUST:
                              </p>
                              <ul>
                                <li>
                                  <p>
                                    {" "}
                                    Have been purchased from FLUOFeelAlive.com
                                    or FLUO HQ.
                                  </p>
                                </li>
                                <li>
                                  {" "}
                                  <p>
                                    Not be labeled as a clearance item. (Items
                                    on markdown qualify for returns, clearance
                                    items will be clearly identified on products
                                    pages.)
                                  </p>
                                </li>
                                <li>
                                  {" "}
                                  <p>
                                    {" "}
                                    Be submitted for return or exchange within
                                    30 days of receiving.
                                  </p>
                                </li>
                                <li>
                                  {" "}
                                  <p>Be clean, unused, and undamaged.</p>
                                </li>
                                <li>
                                  {" "}
                                  <p>Include original hang tags.</p>
                                </li>
                                <li>
                                  {" "}
                                  <p>
                                    Include any gifts that came with the order.
                                  </p>
                                </li>
                              </ul>

                              <p>
                                If you notice within 14 days of purchase that
                                your gear has dropped in price, contact us with
                                your order details and we will refund you the
                                difference.
                              </p>
                              <p>
                                Orders that arrive with factory defects may be
                                refunded within 60 days of delivery.
                              </p>
                              <p>
                                Customers are responsible for their products
                                until they are delivered to us for return or
                                exchange. (We recommed getting tracking
                                insurance on your shipment.)
                              </p>
                              <div className="mt-5  text-center">
                                {" "}
                                <a className="returns-button" href="#">
                                  START RETURN/EXCHANGE
                                </a>
                              </div>
                            </div>
                          </TabPane>
                          <TabPane tabId="10">
                            <LazyLoadComponent>
                              <WebriqForm
                                webriqform="true"
                                name="Join the Revolution"
                                id="revolution"
                                className="revolution-form"
                                data-form-id="41f0cfaf-86a5-4a22-af53-7bbfdc1f46c2"
                                data-thankyou-url="/thank-you"
                              >
                                <div className="form-group">
                                  <label className="mt-4">
                                    First Name{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <input
                                    type="firstname"
                                    className="form-control"
                                    name="First Name"
                                    required
                                  />

                                  <label className="mt-4">
                                    Last Name{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <input
                                    type="lastname"
                                    className="form-control"
                                    name="Last Name"
                                    required
                                  />

                                  <label className="mt-4">
                                    Order Number{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <input
                                    type="primarynum"
                                    className="form-control"
                                    name="Order Number"
                                    required
                                  />

                                  <label className="mt-4">
                                    Items(s) to Return{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <input
                                    type="primarynum"
                                    className="form-control"
                                    name="Items(s) to Return"
                                    required
                                  />

                                  <label className="mt-4">
                                    Picture of Item(s){" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <br />
                                  <input
                                    type="file"
                                    id="myFile"
                                    name="Picture of Item(s)"
                                    multiple
                                  />

                                  <div className="webriq-recaptcha" />
                                  <button
                                    className="footer-button mt-4"
                                    type="submit"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </WebriqForm>
                            </LazyLoadComponent>
                          </TabPane>
                        </TabContent>
                      </div>
                    </TabPane>
                    <TabPane tabId="9">
                      {" "}
                      <div className="tab-content-box text-center">
                        <Helmet>
                          <script
                            type="text/javascript"
                            src="https://assets.99minds.io/live/giftcard/bundle.js"
                          ></script>
                        </Helmet>
                        {/* <Script>
                          {`GiftcardWidget.init({
                            container: "#giftcard-container",
                            client_id: 'key_live_rMAR_qiCEFETLIIROp0XqHyEz86mh0JzkAo69lJJLyI',
                            platform: 'BIGCOMMERCE'
                          });`}
                        </Script> */}

                        <div id="giftcard-container"></div>
                      </div>
                    </TabPane>
                  </TabContent>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default HelpCenter
